<template>
  <div id="app" class="app md:md-app">
    <audio
      v-if="$store.state.playSoundscape"
      autoplay
      loop
      src="@/assets/audio/soundscape.mp3"
    />
    <component v-bind:is="$store.state.view"></component>
    <!-- <CancelButton v-if="$store.state.view !== 'Standby'"/> -->
    <ErrorMessage v-if="$store.state.errorMessage"/>
  </div>
</template>

<script>
import Breathing from './views/Breathing.vue';
import CancelButton from './components/CancelButton.vue';
import Complete from './views/Complete.vue';
import Congratulations from './views/Congratulations.vue';
import ErrorMessage from './components/ErrorMessage.vue';
import IconSelect from './views/IconSelect.vue';
import Intro from './views/Intro.vue';
import LetsBegin from './views/LetsBegin.vue';
import MemeSelect from './views/MemeSelect.vue';
import Questions from './views/Questions.vue';
import Sharing from './views/Sharing.vue';
import Standby from './views/Standby.vue';
import Tags from './views/Tags.vue';
import WordEntry from './views/WordEntry.vue';
import WordSubmit from './views/WordSubmit.vue';

export default {
  name: 'App',
  components: {
    Breathing,
    CancelButton,
    Complete,
    Congratulations,
    ErrorMessage,
    IconSelect,
    Intro,
    LetsBegin,
    MemeSelect,
    Questions,
    Sharing,
    Standby,
    Tags,
    WordEntry,
    WordSubmit,
  },
};
</script>

<style>
@font-face {
  font-family: "Avenir";
  src:  url("~@/assets/fonts/AvenirLight.otf");
  font-weight: normal;
}

@font-face {
  font-family: "Icomoon";
  src:  url("~@/assets/fonts/icomoon.ttf");
  font-weight: normal;
}

@font-face {
  font-family: "Avenir";
  src:  url("~@/assets/fonts/AvenirMedium.otf");
  font-weight: 500;
}

@font-face {
  font-family: "Avenir";
  src:  url("~@/assets/fonts/AvenirBlack.otf");
  font-weight: bold;
}

.app {
  color: #5e5b5c;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 1em;
  max-width: 100vw;
  text-align: center;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}

.text-container {
  margin: auto;
  margin-bottom: 50px;
  margin-top: 50px;
  max-width: 90vw;
  min-height: calc(100vh - 100px);
  position: relative;
  text-align: left;
}

@responsive {
  .md-app {
    font-size: 18.5pt;
    user-select: none;
  }

  .md-text-container {
    margin-bottom: 8vh;
    margin-top: 8vh;
    max-width: 70vw;
    min-height: calc(100vh - 16vh);
    text-align: left;
  }
}
</style>
